import { BoxProps } from '@mui/material';
import { Currency } from '@synergy/models';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';

import { OrderLimitBase } from './order-limit-base';

export interface OrderLimitMonthProps extends BoxProps {
    currentSum: number;
    currency?: Currency;
    limit: number;
}

export const OrderLimitMonth = (props: OrderLimitMonthProps): ReactElement => {
    const { currentSum, limit, currency, ...orderLimitProps } = props;

    const tooltipTitle = (): ReactElement => {
        return (
            <>
                <PoolFormattedMessage
                    id="app.orderLimit.tooltipMonthlyOrder"
                    values={{
                        limit: (
                            <FormattedNumber
                                value={limit}
                                style="currency"
                                currency={props.currency}
                                maximumFractionDigits={0}
                            />
                        ),
                    }}
                />{' '}
                {currentSum > limit ? <FormattedMessage id="app.orderLimit.exceeded" /> : ''}
            </>
        );
    };

    return (
        <OrderLimitBase
            {...orderLimitProps}
            title={<FormattedMessage id="app.orderLimit.monthlyOrderLimit" />}
            limit={limit}
            currentSum={currentSum}
            currency={currency}
            tooltipRender={tooltipTitle}
        />
    );
};
